"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const check_1 = require("../common/check");
const CreaseEdgeRef_1 = require("./CreaseEdgeRef");
/**
 * A closed loop of references to edges in a Crease object.
 */
class CreaseEdgeLoop {
    /**
     * Constructs a CreaseEdgeLoop object.
     * @param {CreaseEdgeRef[]} edgeRefs An array of edge references forming a closed loop.
     */
    constructor(edgeRefs) {
        // Check inputs.
        check_1.check.isArray('edgeRefs', edgeRefs, [2, Infinity], (name, edgeRef, i) => {
            check_1.check.isInstanceOf(name, edgeRef, CreaseEdgeRef_1.CreaseEdgeRef);
            check_1.check.equals(`${name}.vertex2.index`, edgeRef.vertex2.index, edgeRefs[(i + 1) % edgeRefs.length].vertex1.index);
        });
        this._edgeRefs = edgeRefs;
    }
    /**
     * Returns an array of edge references.
     * @returns {CreaseEdgeRef[]} An array of edge references.
     */
    get edgeRefs() {
        return this._edgeRefs;
    }
    /**
     * Returns an array of vertices.
     * @returns {CreaseVertex[]} An array of vertices.
     */
    get vertices() {
        return this.edgeRefs.map(edgeRef => edgeRef.vertex1);
    }
    /**
     * Returns the edge reference used by this loop to refer to the given edge, if any.
     * @param {CreaseEdge} edge An edge.
     * @returns {CreaseEdgeRef | undefined} The edge reference used by this loop to refer to the
     * given edge, or undefined.
     */
    findEdgeRef(edge) {
        return this.edgeRefs.find(edgeRef => edgeRef.edge === edge);
    }
    /**
     * Removes any edge references used by this loop to refer to the given edge. Used internally by
     * `CreaseBuilder._deleteEdges`.
     * @param edge An edge.
     */
    removeEdgeRefs(edge) {
        this._edgeRefs = this._edgeRefs.filter(edgeRef => edgeRef.edge !== edge);
    }
    /**
     * Returns an object that can be serialized using `JSON.stringify`.
     * @returns {CreaseJSONEdgeLoop} The serializable representation of this edge loop.
     */
    toJSON() {
        return { edgeRefs: this.edgeRefs.map(edgeRef => edgeRef.toJSON()) };
    }
}
exports.CreaseEdgeLoop = CreaseEdgeLoop;
//# sourceMappingURL=CreaseEdgeLoop.js.map